import { checkPermissions } from "src/components/Permissions/helper";
import { PermissionEnum } from "src/components/Permissions/types";
import { AppContext } from "src/context/AppContext";
import { useContext } from "react";

type PermissionChecks = {
  hasCreateExtractPermissions: boolean;
  hasCreateHandoverPermissions: boolean;
  hasCreateMessagePermissions: boolean;
  hasCreateRequestPermissions: boolean;
  hasManageCompaniesPermissions: boolean;
  hasManageContactsPermissions: boolean;
  hasManageHandoversPermissions: boolean;
  hasManageUsersPermissions: boolean;
  hasViewAllRequestsPermissions: boolean;
  hasViewAllCompaniesPermissions: boolean;
  hasCreateCustomerExtractPermissions: boolean;
  isHomeUser: boolean;
};

export const usePermissions = (): PermissionChecks => {
  const {
    context: { user },
  } = useContext(AppContext);

  const isHomeUser =
    !user?.main_company &&
    !checkPermissions(user?.permissions, PermissionEnum.VIEW_ALL_REQUESTS);

  // Return an object with all permission checks
  return {
    hasCreateExtractPermissions: checkPermissions(
      user?.permissions,
      PermissionEnum.CREATE_EXTRACT
    ),
    hasCreateHandoverPermissions: checkPermissions(
      user?.permissions,
      PermissionEnum.CREATE_HANDOVER
    ),
    hasCreateMessagePermissions: checkPermissions(
      user?.permissions,
      PermissionEnum.CREATE_MESSAGE
    ),
    hasCreateRequestPermissions: checkPermissions(
      user?.permissions,
      PermissionEnum.CREATE_REQUEST
    ),
    hasManageCompaniesPermissions: checkPermissions(
      user?.permissions,
      PermissionEnum.MANAGE_COMPANIES
    ),
    hasManageContactsPermissions: checkPermissions(
      user?.permissions,
      PermissionEnum.MANAGE_CONTACTS
    ),
    hasManageHandoversPermissions: checkPermissions(
      user?.permissions,
      PermissionEnum.MANAGE_HANDOVERS
    ),
    hasManageUsersPermissions: checkPermissions(
      user?.permissions,
      PermissionEnum.MANAGE_USERS
    ),
    hasViewAllRequestsPermissions: checkPermissions(
      user?.permissions,
      PermissionEnum.VIEW_ALL_REQUESTS
    ),
    hasViewAllCompaniesPermissions: checkPermissions(
      user?.permissions,
      PermissionEnum.VIEW_ALL_COMPANIES
    ),
    hasCreateCustomerExtractPermissions: checkPermissions(
      user?.permissions,
      PermissionEnum.CREATE_CUSTOMER_EXTRACT
    ),
    isHomeUser,
  };
};
